import * as React from "react";
import Main from "./components/main/main";
import Footer, { FooterConfiguration } from "./components/footer/footer";

const App = () => {
    const conf: FooterConfiguration = {};
    const [footerConfig, setFooterConfig] = React.useState(conf);
    return (
        <div className="appContainer">
            <Main setFooter={setFooterConfig} />
            {footerConfig.Button && <Footer config={footerConfig} />}
        </div>
    );
};

export default App;
